export const CALL_SIDEBAR_WIDTH = 310;
